import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Row
} from 'react-bootstrap';

import { formatPhone } from '../helpers/formatting';
import { isEmail, isPhone } from '../helpers/validation';
import validateInviteAction from '../actions/validateInviteAction';

import '../App.css';

export default function CustomerForm(props) {
  const [firstNameInvalid, setFirstNameInvalid] = useState(false);
  const [lastNameInvalid, setLastNameInvalid] = useState(false);
  const [emailInvalid, setEmailInvalid] = useState(false);
  const [phoneInvalid, setPhoneInvalid] = useState(false);
  const [phone, setPhone] = useState();

  const handleValidateChange = async e => {
    switch (e.target.name) {
      case 'firstName':
        if (!e.target.value) {
          setFirstNameInvalid(true);
          return;
        } else {
          setFirstNameInvalid(false);
        }
        break;
      case 'email':
        setEmailInvalid(!isEmail(e.target.value));
        return;
        break;
      case 'phone':
        if (!e.target.value) {
          setPhoneInvalid(false);  
          return
        }      
        setPhoneInvalid(!isPhone(e.target.value));
        return;
        break;
    }
    //props.handleChange(e.target.name, e.target.value);
  }


  const formatPhoneInput = (e) => {
    const formattedPhone = formatPhone(e.target.value);
    setPhone(formattedPhone);
  };

  return (
    <Container fluid className="text-start ">
      <Row>
        <Col xs={12}>
          <Form noValidate>

            <Form.Group className="mb-3" controlId="formFirstName">
              <Form.Label>First name</Form.Label>
              <Form.Control 
                isInvalid={firstNameInvalid} 
                type="text" 
                placeholder="Enter first name" 
                name="firstName" 
                defaultValue={props.firstName} 
                onBlur={e => handleValidateChange(e)} 
                onChange={e => props.handleChange(e.target.name, e.target.value)} 
              />
              <Form.Control.Feedback type="invalid">
                Please enter customer first name.
              </Form.Control.Feedback>                  
            </Form.Group>

            <Form.Group className="mb-3" controlId="formFirstName">
              <Form.Label>Last name</Form.Label>
              <Form.Control 
                isInvalid={lastNameInvalid} 
                type="text" 
                placeholder="Enter last name" 
                name="lastName" 
                defaultValue={props.lastName} 
                onBlur={e => handleValidateChange(e)} 
                onChange={e => props.handleChange(e.target.name, e.target.value)} 
              />
              <Form.Control.Feedback type="invalid">
                Please enter customer last name.
              </Form.Control.Feedback>                  
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>Email Address</Form.Label>
              <Form.Control 
                isInvalid={emailInvalid} 
                type="text" 
                placeholder="Enter your email address" 
                name="email" 
                defaultValue={props.email} 
                onBlur={e => handleValidateChange(e)} 
                onChange={e => props.handleChange(e.target.name, e.target.value)} 
              />
              <Form.Control.Feedback type="invalid">
                Please enter a valid email.
              </Form.Control.Feedback>     
            </Form.Group>

            <Form.Group as={Row} className="mb-3" controlId="formBasicEmail">
              <Form.Label>Phone</Form.Label>
              <Col>
                  <Form.Control 
                    isInvalid={phoneInvalid} 
                    type="phone" 
                    placeholder="(xxx) xxx-xxxx" 
                    name="phone" 
                    defaultValue={props.phone} 
                    onBlur={e => handleValidateChange(e)} 
                    onChange={(e) => formatPhoneInput(e)}
                  />              
              </Col>
            </Form.Group>

          </Form>
        </Col>
      </Row>
    </Container>
  );
}
